import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ValidacaoResult } from '../../interfaces/validacao.interface';
import { PopupValidacaoComponent } from '../../shared/stepper-navigation/components/popup-validacao/popup-validacao.component';

@Injectable({
  providedIn: 'root'
})
export class ValidacaoEtapaService {
  // Função callback que o layout registra para validar a tela atual
  private validarTelaAtualCallback: (() => ValidacaoResult) | null = null;

  // Função callback para restaurar valores padrão
  private restaurarValoresCallback: (() => void) | null = null;

  constructor(
    private router: Router,
    private dialog: MatDialog,
    private toastr: ToastrService
  ) { }

  // O layout registra uma função para validar a tela atual
  registrarValidadorLayout(
    validarCallback: () => ValidacaoResult,
    restaurarCallback: () => void
  ): void {
    this.validarTelaAtualCallback = validarCallback;
    this.restaurarValoresCallback = restaurarCallback;
  }

  // Remove os callbacks quando necessário
  removerValidadorLayout(): void {
    this.validarTelaAtualCallback = null;
    this.restaurarValoresCallback = null;
  }

  // Valida a tela atual (chamado internamente ou externamente)
  validarTelaAtual(): ValidacaoResult {
    if (!this.validarTelaAtualCallback) {
      return { valido: true, mensagens: [] };
    }

    return this.validarTelaAtualCallback();
  }

  // Valida tela atual e mostra popup se necessário
  async validarParaNavegacao(): Promise<boolean> {
    const resultado = this.validarTelaAtual();

    if (!resultado.valido) {
      this.toastr.error('Verifique as inconsistências.', 'Atenção!');

      // Abre popup e aguarda decisão do usuário
      const continuarMesmoAssim = await this.mostrarPopupValidacao(resultado.mensagens, '');

      if (continuarMesmoAssim) {
        this.restaurarValoresPadrao();
        return true; // Permite navegação após restaurar valores
      }

      return false; // Usuário optou por corrigir -> bloqueia navegação e mantém na mesma tabela
    }

    // Validação passou, pode navegar normalmente
    return true;
  }

  // Restaura valores padrão da tela atual
  private restaurarValoresPadrao(): void {
    if (this.restaurarValoresCallback) {
      this.restaurarValoresCallback();
    }
  }

  private mostrarPopupValidacao(mensagens: string[], proximaRota: string): Promise<boolean> {
    return new Promise((resolve) => {
      const dialogRef = this.dialog.open(PopupValidacaoComponent, {
        width: '500px',
        disableClose: true,
        data: {
          mensagens,
          proximaRota
        }
      });

      const componentInstance = dialogRef.componentInstance;

      // Configura o popup
      componentInstance.visivel = true;
      componentInstance.permitirContinuar = true;
      componentInstance.mensagensInconsistencia = mensagens;

      // Escuta eventos do popup
      componentInstance.continuarMesmoAssim.subscribe(() => {
        dialogRef.close();
        resolve(true); // Continuar mesmo assim
      });

      componentInstance.corrigirErros.subscribe(() => {
        dialogRef.close();
        resolve(false); // Corrigir erros
      });

      componentInstance.fechar.subscribe(() => {
        dialogRef.close();
        resolve(false); // Fechar = corrigir erros
      });
    });
  }
}